export const LAST_NAME_PLACEHOLDER = 'Last Name';

export enum LOCK_NAMES {
  BUSINESS_TYPE = 'account.business_type',
  PROVINCE = 'account.province',
  REGION = 'account.region',
  STREET = 'account.street',
  SUBURB = 'account.suburb',
  TRADING_AS = 'account.trading_as',
  ZIP_CODE = 'account.zip_code',
  EMAIL = 'contact.email',
  FIRST_NAMES = 'contact.first_names',
  PHONE = 'contact.phone',
  ID_NUMBER = 'contact.id_number',
  AGENT_ID = 'lead.agentId',
  MOBILE_NUMBER = 'lead.mobile_number',
  TURNOVER = 'lead.monthly_card_turnover',
}

export const isLocked = (lockedFieldList: string | undefined, field: LOCK_NAMES) => {
  return (lockedFieldList || '').includes(field);
};
